import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { DatePicker } from "react-advance-jalaali-datepicker";
import cookie from "js-cookie";
import moment from "moment";
import messageCategoryUserSitePublishers from "../../../messages/category-user-site-publishers";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import Pagination from "./Pagination";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import validateFormPermission from "../../../validtions/forms/category-user-site-publishers/add-categories-user-site-publishers";
import typeGroupSitePublisher from "./TypeGroupSitePublisher";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import TitleBar from "../../partials/content/TitleBar";
import SelectDropDown from "../../partials/content/SelectDropDown";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function EditGroupPublisher({
  categoryUser,
  dataSitePublisher,
  render,
  emptyPositions,
  setPositionsForEdit,
  setTypeAction,
  resetPositionInEditAction,
  resetDate,
  startDate,
  endDate,
  setDates,
}) {
  const [
    categorySitePublisherHasCampaign,
    setCategorySitePublisherHasCampaign,
  ] = useState(false);
  const [categoriesSitePublisher, setCategoriesSitePublisher] = useState([]);
  const [categoryUserSitesPublisherData, setCategoryUserSitesPublisherData] =
    useState();

  const [
    editDateCategoryUserSitePublisher,
    setEditDateCategoryUserSitePublisher,
  ] = useState(false);

  const [sitesPublisher, setSitesPublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [siteNameSearchFilter, setSiteNameSearchFilter] = useState();
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [isCheckPreviousSearchInput, setIsCheckPreviousSearchInput] =
    useState(false);
  const [message, setMessage] = useState();

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };
  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.EDIT,
  });

  const params = useParams();
  const typeAdvertisePublisher = params.typeAdvertise;
  const categorySitePublisherID = params.id;

  const history = useHistory();

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const setInputSearchSitePublisher = (value = "") => {
    document.querySelector("#site").value = value;
  };

  useEffect(() => {
    if (categoriesSitePublisher.length > 0) {
      return;
    }
    getCategoriesSitesPublisher();
  }, []);

  useEffect(() => {
    checkPreviousSearchInput();
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      emptyPositions();
      resetPositionInEditAction();
      resetDate();
    }
  }, []);

  useEffect(() => {
    checkCategorySitePublisherHasCampaign(categorySitePublisherID);
    getCategoryUserSitesPublisherData();
  }, []);

  useEffect(() => {
    if (!isCheckPreviousSearchInput) {
      return;
    }
    getSitesPublisher();
  }, [
    currentPage,
    siteNameSearchFilter,
    categoryNameSearchFilter,
    isCheckPreviousSearchInput,
  ]);

  const [isShowWebSite, setIsShowWebSite] = useState(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      startDate = null;
      endDate = null;
    }
    if (startDate !== null && endDate !== null) {
      return true;
    }

    return true;
    // return false;
  });

  if (!startDate) {
    startDate = moment(helpersTime.getDateNow())
      .add(1, "days")
      .format("YYYY/M/D");
  }

  if (!endDate) {
    endDate = moment(helpersTime.getDateNow())
      .add(2, "days")
      .format("YYYY/M/D");
  }

  const checkPreviousSearchInput = () => {
    const previousSearchInputPage = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_PAGE
    );
    const previousSiteNameSearch = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH
    );
    const previousCategoryNameSearchFilter = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );

    if (previousSearchInputPage) {
      setCurrentPage(previousSearchInputPage);
    }

    if (previousSiteNameSearch != undefined) {
      setSiteNameSearchFilter(previousSiteNameSearch);
      setInputSearchSitePublisher(previousSiteNameSearch);
    }

    if (previousCategoryNameSearchFilter) {
      setCategoryNameSearchFilter(decodeURI(previousCategoryNameSearchFilter));
    }

    removeCookiePreviousSearchInput();
    setIsCheckPreviousSearchInput(true);
  };

  const removeCookiePreviousSearchInput = () => {
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_PAGE);
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH);
    cookie.remove(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );
  };

  const setSearchInputOnCookie = () => {
    if (currentPage) {
      cookie.set(actionCookie.GROUP_SITE_PUBLISHER_PAGE, currentPage);
    }
    if (siteNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH,
        siteNameSearchFilter
      );
    }
    if (categoryNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER,
        encodeURIComponent(categoryNameSearchFilter)
      );
    }
  };

  const checkCategorySitePublisherHasCampaign = async (
    categorySitePublisherID
  ) => {
    const campaign = await sendRequestGetCampaign(categorySitePublisherID);
    const result = Object.keys(campaign).length === 0 ? false : true;
    setCategorySitePublisherHasCampaign(result);
  };

  const sendRequestGetCampaign = async (categorySitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let campaigns;
    try {
      campaigns = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/category-user-site-publisher/" +
          categorySitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return campaigns.data.data;
  };

  const getCategoryUserSitesPublisherData = async () => {
    const categoryUserSitesPublisherData =
      await sendRequestCategoryUserSitesPublisherData(categorySitePublisherID);
    if (!categoryUserSitesPublisherData) {
      return;
    }

    setCategoryUserSitesPublisherData(categoryUserSitesPublisherData);

    if (Object.keys(categoryUserSitesPublisherData).length !== 0) {
      if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
        setDates({
          name_category: categoryUserSitesPublisherData.name,
          start_date: categoryUserSitesPublisherData.start_date,
          end_date: categoryUserSitesPublisherData.end_date,
        });
        setPositionsForEdit({
          dataSitePublisher: categoryUserSitesPublisherData.sites,
        });
      }
    }
  };

  const sendRequestCategoryUserSitesPublisherData = async (
    categorySitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let categoryUserSitesPublisherData;
    try {
      categoryUserSitesPublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          categorySitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryUserSitesPublisherData.data.data;
  };

  const getCategoriesSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoryAllPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }
    setCategoriesSitePublisher(categories);
  };

  const getSitesPublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitesPublisher = await sendRequestSitesPublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!sitesPublisher) {
      return;
    }

    setSitesPublisher(sitesPublisher.data);
    setCountPage(sitesPublisher.total_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (siteNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&site=${siteNameSearchFilter}`;
    }
    if (categoryNameSearchFilter) {
      if (categoryNameSearchFilter != "همه دسته ها") {
        searchFilterQuery = `${searchFilterQuery}&category=${categoryNameSearchFilter}`;
      }
    }

    return searchFilterQuery;
  };

  const generateBodyTable = (sitesPublisher) => {
    return sitesPublisher.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div className="d-flex justify-content-around">
              <span>
                <i className="fa fa-mobile-alt"></i>
              </span>
              <span>
                <i className="fa fa-desktop"></i>
              </span>
            </div>
          </td>
          <td>
            <Link
              onClick={setSearchInputOnCookie}
              to={`/publishers/${sitePublisher.id}/all-page/${categorySitePublisherID}`}
              className="btn btn-info"
            >
              پیش نمایش جایگاه های نمایش تبلیغات
            </Link>
          </td>
        </tr>
      );
    });
  };

  const generateTagSitesPublisher = () => {
    return (
      <>
        <div className="col-12 pb-3">
          <div className="table-responsive pt-3">
            <table className="table table-hilite tbl-td-white-space table-hover">
              <thead>
                <tr>
                  <td>#</td>
                  <td>نمایش دهنده</td>
                  <td>دسته بندی موضوع</td>
                  <td>قابل نمایش در</td>
                  <td>نمایش صفحات</td>
                </tr>
              </thead>
              <tbody>
                {sitesPublisher.length > 0 ? (
                  generateBodyTable(sitesPublisher)
                ) : (
                  <tr>
                    <td
                      colspan="5"
                      className="text-center"
                      style={{ borderBottomRightRadius: "25px" }}
                    >
                      هیچ سایتی با این مشخصات موجود نیست.
                    </td>
                  </tr>
                )}

                {/* {sitesPublisher.map((sitePublisher, index) => {
                  return (
                    <tr key={index}>
                      <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                      <td>
                        <a href={sitePublisher.url} target="_blank">
                          {sitePublisher.url}
                        </a>
                      </td>
                      <td>{sitePublisher.categories.join(" - ")}</td>
                      <td>
                        <div className="d-flex justify-content-around">
                          <span>
                            <i className="fa fa-mobile-alt"></i>
                          </span>
                          <span>
                            <i className="fa fa-desktop"></i>
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span>
                            <Link
                              onClick={setSearchInputOnCookie}
                              to={`/publishers/${sitePublisher.id}/all-page/${categorySitePublisherID}`}
                              className="btn btn-info"
                            >
                              جایگاه های نمایش تبلیغات
                            </Link>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })} */}
              </tbody>
            </table>
          </div>
        </div>
        <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
          {countPage > 1 && generatePagination()}
        </div>
      </>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = () => {
    return (
      <Pagination
        countPage={countPage}
        currentPage={currentPage}
        paginationItemOnClickHandler={paginationItemOnClickHandler}
      />
    );
  };

  const sendRequestSitesPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return sitePublishers.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetCategoryAllPublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    const resultValidateFormPermission = validateFormPermission(dataForm);

    if (resultValidateFormPermission != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidateFormPermission,
        class_icon: "fa fa-exclamation-triangle",
      });

      goScrollIntoTag("add-group-site-publisher");
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEditCategoryUserSitePublisher =
      await sendRequestEditCategoryUserSitePublisher(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestEditCategoryUserSitePublisher) {
      return;
    }

    emptyPositions();
    resetPositionInEditAction();
    history.push("/publishers/all");
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendRequestEditCategoryUserSitePublisher = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          categorySitePublisherID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("add-group-site-publisher");
      return false;
    }
  };

  const getDataForm = () => {
    const typeGroupPublisher = typeGroupSitePublisher.getTypeGroupPublisher(
      typeAdvertisePublisher
    );
    return {
      name: document.getElementById("name").value,
      type_id: "" + typeGroupPublisher,
      amount: getPriceCategoryUserSitePublisher(dataSitePublisher) + "",
      sites: dataSitePublisher,
      start_date: startDate,
      end_date: endDate,
    };
  };

  const showSelectCategorySitePublisher = () => {
    let categoriesSitesPublishersForDropDown = categoriesSitePublisher.filter(
      (category) => category.name != categoryUser
    );

    categoriesSitesPublishersForDropDown =
      categoriesSitesPublishersForDropDown.map((category) => {
        return { value: category.id, label: category.name };
      });

    categoriesSitesPublishersForDropDown = [
      { value: 0, label: "همه دسته ها" },
      ...categoriesSitesPublishersForDropDown,
    ];

    let itemSelected;
    if (categoryNameSearchFilter) {
      itemSelected = categoriesSitesPublishersForDropDown.filter(
        (category) => category.label == categoryNameSearchFilter
      );

      if (itemSelected.length > 0) {
        itemSelected = {
          label: itemSelected[0].label,
          value: itemSelected[0].value,
        };
      }
    }

    return (
      <SelectDropDown
        data={categoriesSitesPublishersForDropDown}
        itemSelected={itemSelected}
        setItemHandler={(newItemSelected) => {
          setCategoryNameSearchFilter(newItemSelected.label);
          setCurrentPage(1);
          setSiteNameSearchFilter();
          setInputSearchSitePublisher();
        }}
      />
    );
  };

  const generatePageDataReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...sitePublisherData.positions },
      {
        one: "",
        two: "",
      },
    ];
  };

  const checkStartDateEntered = (startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    if (moment(startDateEntered).diff(startDate, "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_PAST_FROM_CURRENT_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(startDateEntered).diff(currentDate, "days");
    let maxCountDaysCategoryUserSitePublisherForStartDate =
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      ) - 1;
    if (differentDates > maxCountDaysCategoryUserSitePublisherForStartDate) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.START_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });

      return false;
    }

    return true;
  };

  const checkEndDateEntered = (endDateEntered, startDateEntered) => {
    startDateEntered = helpersTime.convertJalaliToGregorian(startDateEntered);
    endDateEntered = helpersTime.convertJalaliToGregorian(endDateEntered);

    if (moment(endDateEntered).diff(moment(startDateEntered), "d") < 0) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_PAST_FROM_START_DATE,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let currentDate = moment(new Date().toISOString().split("T")[0]);
    const differentDates = moment(endDateEntered).diff(currentDate, "days");
    if (
      differentDates >
      parseInt(
        process.env.REACT_APP_MAX_COUNT_DAYS_CATEGORY_USER_SITE_PUBLISHER
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: messageCategoryUserSitePublishers.END_DATE_IS_TOO_MUCH,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const showWebSites = (e) => {
    e.preventDefault();
    const startDateEntered = document.querySelector(".start-date input").value;
    const endDateEntered = document.querySelector(".end-date input").value;
    const nameCategory = document.querySelector("#name").value.trim();

    if (!checkStartDateEntered(startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    if (!checkEndDateEntered(endDateEntered, startDateEntered)) {
      helperSpinner.scrollForSeeMessage(".card");
      return;
    }

    setDates({
      name_category: nameCategory,
      start_date: helpersTime.convertJalaliToGregorian(startDateEntered),
      end_date: helpersTime.convertJalaliToGregorian(endDateEntered),
    });
    setEditDateCategoryUserSitePublisher(false);
    emptyPositions();
    setIsShowWebSite(true);
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    const newSitePublisherData = { ...sitePublisherData };
    for (const key in newSitePublisherData) {
      if (key == "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const generateFormEditDateCategoryUserSitePublisher = () => {
    return (
      <div className="form-group">
        <div className="container-fluid p-0">
          <div className="row align-items-end">
            {isShowWebSite ? (
              <div className="col-12">
                <div className="table-responsive pt-3">
                  <table className="table table-hilite">
                    <thead>
                      <tr>
                        <td className="text-nowrap">
                          ارزش یک شبانه روز گروه نمایش دهنده{" "}
                        </td>
                        <td>تاریخ شروع </td>
                        <td>تاریخ پایان </td>
                        <td> دریافت لیست گروه بنری </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span className="px-2 letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                getPriceCategoryUserSitePublisher(
                                  dataSitePublisher
                                )
                              )
                            )}
                          </span>
                          <span className="pr-2">تومان</span>
                        </td>
                        <td>
                          <span className="number-finance">
                            {helpersNumbers.toPersianNum(startDate)}
                          </span>
                        </td>
                        <td>
                          <span className="number-finance">
                            {helpersNumbers.toPersianNum(endDate)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <>
                <div className="alert alert-warning w-100">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        در صورت ویرایش تاریخ شروع و پایان جایگاه های از قبل
                        ایجاد شده حذف شده
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="col-12 col-md-4 pb-3">
                  <div>
                    <div>
                      <label>تاریخ شروع</label>
                    </div>
                    <div className="custom-data-picker start-date">
                      {isShowWebSite ? (
                        <></>
                      ) : (
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            startDate
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-4 pb-3">
                  <div>
                    <div>
                      <label>تاریخ پایان</label>
                    </div>
                    <div className="custom-data-picker end-date">
                      {isShowWebSite ? (
                        <></>
                      ) : (
                        <DatePicker
                          placeholder="انتخاب تاریخ"
                          format="jYYYY/jMM/jDD"
                          preSelected={helpersTime.convertGregorianToJalali(
                            endDate
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-12 col-md-4 pb-3">
              {isShowWebSite ? (
                <></>
              ) : (
                <button
                  className="btn btn-success w-100"
                  onClick={showWebSites}
                  disabled={isShowWebSite ? "disabled" : ""}
                >
                  اعمال تاریخ جدید و نمایش سایت ها
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش کردن گروه سایت های نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-group-site-publisher">
              <div className="text-left pb-2">
                <Link to="/publishers/all" className="btn btn-success">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}

              {categorySitePublisherHasCampaign === true ? (
                <div className="alert alert-warning">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        گروه نمایش دهنده شما یک کمپین دارد و قابل ویرایش نیست.
                      </p>

                      <li>
                        <p className="text-justify">
                          جهت مشاهده یکپارچه گروه نمایش دهنده خود از دکمه سبز
                          رنگ پایین سمت چپ استفاده کنید.
                        </p>
                      </li>
                    </li>
                  </ul>
                </div>
              ) : (
                <div className="alert alert-warning">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        ویرایش گروه نمایش دهنده فقط در حالتی که به کمپینی تعلق
                        نداشته باشد مقدور است.
                      </p>

                      <li>
                        <p className="text-justify">
                          جهت مشاهده یکپارچه گروه نمایش دهنده خود از دکمه خروجی
                          فایل Execl استفاده کنید.
                        </p>
                      </li>
                    </li>
                  </ul>
                </div>
              )}

              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>نام گروه</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="نام گروه"
                    id="name"
                    defaultValue={categoryUserSitesPublisherData?.name}
                    required
                  />
                </div>

                {editDateCategoryUserSitePublisher &&
                  generateFormEditDateCategoryUserSitePublisher()}

                <div className="form-group">
                  <div className="table-responsive pt-3">
                    <table className="table table-hilite">
                      <thead>
                        <tr>
                          <td className="text-nowrap">
                            ارزش یک شبانه روز گروه نمایش دهنده{" "}
                          </td>
                          <td>تاریخ شروع </td>
                          <td>تاریخ پایان </td>
                          <td>عملیات</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="px-2 letter-spacing-finance-number">
                              {helpersNumbers.toPersianNum(
                                helpersNumbers.toFormatFinanceNumber(
                                  getPriceCategoryUserSitePublisher(
                                    dataSitePublisher
                                  )
                                )
                              )}
                            </span>
                            <span className="pr-2">تومان</span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {categoryUserSitesPublisherData !== undefined ? (
                                helpersNumbers.toPersianNum(
                                  helpersTime.convertGregorianToJalali(
                                    startDate
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </span>
                          </td>
                          <td>
                            <span className="number-finance">
                              {categoryUserSitesPublisherData !== undefined ? (
                                helpersNumbers.toPersianNum(
                                  helpersTime.convertGregorianToJalali(endDate)
                                )
                              ) : (
                                <></>
                              )}
                            </span>
                          </td>
                          <td className="d-flex">
                            {editDateCategoryUserSitePublisher ? (
                              <span>
                                <span
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(false);
                                    setIsShowWebSite(true);
                                  }}
                                >
                                  انصراف از ویرایش تاریخ شروع و پایان و نمایش
                                  سایت ها{" "}
                                </span>
                              </span>
                            ) : (
                              <span>
                                <span
                                  className="btn btn-success"
                                  onClick={() => {
                                    setEditDateCategoryUserSitePublisher(true);
                                    setIsShowWebSite(false);
                                  }}
                                >
                                  ویرایش تاریخ شروع و تاریخ پایان
                                </span>
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="form-group">
                  <div
                    className={`container-fluid p-0 ${
                      isShowWebSite ? "" : "d-none"
                    } `}
                  >
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div>
                          <label>جستجو آدرس سایت</label>
                        </div>
                        <div>
                          <input
                            onKeyUp={(e) => {
                              setSiteNameSearchFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="form-control"
                            id="site"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div>
                          <div>
                            <label>
                              دسته بندی نمایش دهنده های مرتبط (برای شما)
                            </label>
                          </div>
                          <div>{showSelectCategorySitePublisher()}</div>
                        </div>
                      </div>

                      {sitesPublisher.length == 0 &&
                      siteNameSearchFilter == null &&
                      categoryNameSearchFilter == null ? (
                        <></>
                      ) : (
                        generateTagSitesPublisher()
                      )}
                    </div>
                    <div className="form-group">
                      {categorySitePublisherHasCampaign === false ? (
                        <button type="submit" className="btn btn-success">
                          ویرایش کردن
                        </button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <PreviewPositionsGroupSitePublisher />
        <ExportFileExcelButton />
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    categoryUser: state.main.categoryUser,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setPositionsForEdit: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_POSITION_FOR_EDIT,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_POSITION_IN_EDIT_ACTION,
        payload: action,
      });
    },
    setDates: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_DATE,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroupPublisher);
